import { Component, OnChanges, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { API_MAP, API_BASE_FILESERVICE } from 'src/environments/api';
import { Inject, PLATFORM_ID } from '@angular/core';

@Component({
    selector: 'app-secure-image',
    templateUrl: './secure-image.component.html', // <img [src]="dataUrl$ && dataUrl$ | async" class="custom" />
    styleUrls: ['./secure-image.component.scss'],
    standalone: false
})
export class SecureImageComponent implements OnChanges {
    @Input()
    public resize: boolean = true;

    @Input() productList = false;

    @Input() private fill: boolean = false;

    @Input() private circle: boolean = false;

    @Input() private contain: boolean = false;

    @Input() public displayItem: boolean = false;

    @Input() public organisation: boolean = false;

    @Input() public src: string;
    @Input() public isProfilPic: boolean = false;
    @Input() public isComment: boolean = false;
    @Input() public isScreen: boolean = false;

    @Input() private fileId: string = null;
    @Input() profilePublicPage: boolean = false;

    @Input() isProduct: boolean = false;
    
    private fileId$ = new BehaviorSubject(this.fileId);
    dataUrl$ = this.fileId$.pipe(switchMap((fileId) => this.loadFile(fileId)));

    public isUploadedPicture: boolean = true;
    private readonly isBrowser: boolean;

    ngOnChanges(): void {
        this.fileId$.next(this.fileId);
    }

    constructor(
        private httpClient: HttpClient,
        private domSanitizer: DomSanitizer,
        @Inject(PLATFORM_ID) platformId: object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    public loadImage(url: string): Observable<any> {
        if (!url) {
            return of(null);
        }

        if (!this.isBrowser) {
            return of(this.domSanitizer.bypassSecurityTrustResourceUrl(url));
        }

        return this.httpClient.get(url, { responseType: 'blob' }).pipe(
            map((e) => {
                return this.domSanitizer.bypassSecurityTrustResourceUrl(
                    URL.createObjectURL(e)
                );
            }),
            catchError(() => of(this.domSanitizer.bypassSecurityTrustResourceUrl(this.src || url)))
        );
    }

    public loadFile(fileId: string): Observable<any> {
        if (fileId == null) {
            this.isUploadedPicture = false;
            return this.loadImage(this.src);
        }
        this.isUploadedPicture = true;
        if (!this.isBrowser) {
            return of(this.domSanitizer.bypassSecurityTrustResourceUrl(this.src || ''));
        }
        return this.loadImage(
            API_BASE_FILESERVICE +
                API_MAP['files']['GET'].replace(':fileId', fileId)
        );
    }
}
